import DOMPurify from 'dompurify';

export const catColor = (cat: string) => {
  const map: Record<string, string> = {
    'Посуда': '#f59e0b',
    'Декор': '#3b82f6',
    'Сумки': '#10b981',
    'Наборы': '#8b5cf6'
  };
  return map[cat] || '#94a3b8';
};

export const formatPrice = (val: number) => {
  return new Intl.NumberFormat('ru-RU').format(val);
};

export const formatMessageHTML = (text: string) => {
  if (!text) return '';
  const html = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>')
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    .replace(/(\*\*|__)(.*?)\1/g, '<strong>$2</strong>')
    .replace(/(\*|_)(.*?)\1/g, '<em>$2</em>')
    .replace(/^[\s]*[-*]\s+(.*)$/gm, '• $1')
    .replace(/\n/g, '<br/>');

  return DOMPurify.sanitize(html);
};
